__turbopack_context__.v({
  "arrow": "_3Txnma_arrow",
  "card": "_3Txnma_card",
  "date": "_3Txnma_date",
  "eyebrow": "_3Txnma_eyebrow",
  "gradient": "_3Txnma_gradient",
  "grid": "_3Txnma_grid",
  "head": "_3Txnma_head",
  "heading": "_3Txnma_heading",
  "inner": "_3Txnma_inner",
  "meta": "_3Txnma_meta",
  "section": "_3Txnma_section",
  "shader": "_3Txnma_shader",
  "sub": "_3Txnma_sub",
  "tag": "_3Txnma_tag",
  "tagDot": "_3Txnma_tagDot",
  "tagLabel": "_3Txnma_tagLabel",
  "title": "_3Txnma_title",
  "viewAll": "_3Txnma_viewAll",
});
